import { queryOptions } from '@tanstack/react-query';
import type { Empresa } from '@/features/empresa/types/Empresa';
import type { DefaultApiParams } from '@/std/pagination/types';
import { newRequest } from '@/std/api/newRequest';

type ApiEmpresaGetParams = DefaultApiParams;

export const API_EMPRESA_GET_KEY = 'apiEmpresaGet';

function apiEmpresaGet(params?: ApiEmpresaGetParams): Promise<Empresa[]> {
    return newRequest({
        params,
        type: 'get',
        url: 'Empresa/Empresa',
    });
}

export function apiEmpresaGetQueryOptions(params?: ApiEmpresaGetParams) {
    return queryOptions({
        queryFn: () => apiEmpresaGet(params),
        queryKey: [API_EMPRESA_GET_KEY, params],
    });
}
